import React from "react";
import "./linkstab.css";

function LinksTab() {
  const newsletterUrl = process.env.REACT_APP_NEWSLETTER_URL;
  const linkedingUrl = process.env.REACT_APP_LINKEDIN_URL;

  const handleRedirect = (path) => {
    window.open(path, "_blank", "noopener");
  };

  return (
    <div className="links-wrapper" id="newsletter-click">
      <span className="links-simple-span">
        Read our{" "}
        <span
          className="links-supereme-tag"
          onClick={() => handleRedirect(newsletterUrl)}
        >
          Newsletter
          <img
            src="/images/newsletter.svg"
            className="newslettter-image shake"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </span>{" "}
      </span>
      <span className="links-simple-span">
        to gain insights and follow us on
      </span>
      <span className="links-simple-span">
        <span
          className="links-supereme-tag"
          onClick={() => handleRedirect(linkedingUrl)}
        >
          LinkedIn
          <ImageWrapper imgSrc={"/images/linkedin.svg"} />
        </span>{" "}
        to stay updated.
      </span>
    </div>
  );
}

export default React.memo(LinksTab);

const ImageWrapper = ({ imgSrc, className = "shake" }) => {
  return (
    <div className={`image-wrapper-linkstab ${className}`}>
      <img alt="" src={imgSrc} loading="lazy" decoding="async" />
    </div>
  );
};
